import React,{ useState, useEffect } from "react";
import  "../../css/style-new.css";
import  "../../css/developer1.css";
import "../../css/bootstrap.min.css";
import "../../css/font.css";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { associationurl,sportlist, schoolsApiurl } from '../../apis/urls'
import { Multiselect } from "multiselect-react-dropdown";
import { CheckPicker, Loader, Panel } from "rsuite";
import { $ } from "react-jquery-plugin";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { message } from "antd";
import { Checkbox } from "@nextui-org/react";
import confirm from "antd/lib/modal/confirm";

const Editassociation = () => {

    const [res,setRes] = useState([]);
    const [changeAll, setChangeAll] = useState(false);
    const [sports_id, setSports_id] = useState('');
    const [school_id, setSchool_id] = useState([]);
    const [btnLoader, setBtnLoader] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState([]);
    const [userrole, setUserRole] = useState('');
    const [email, setEmail] = useState('');
    

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        startListing();
    },[]);

    const startListing = async() => {
        SportsListing();
    }


    let arr = localStorage.getItem('association');

    let associationIds = arr.split(',');

    const { id } = useParams();

    let schoolArray = []


    const handleSelect = (id, e) => {
        // setSchool_id(id)
            id?.map((item,index) => {
                schoolArray.push(item.id)
            }
            )

            setSchool_id(schoolArray)
            // console.log(schoolArray)
            return schoolArray;
    };
    
    
    const handleRemove = (id) => {

        id?.map((item,index) => {
            schoolArray.push(item.id)
        }
        )

        setSchool_id(schoolArray)

    };
    
    let navigate = useNavigate();
    const RoutToList = () =>{

        let userrole = localStorage.getItem('userrole');

        let path = 'newPath'; 
        if(userrole === 'SUPERADMIN'){
            navigate("/associations")
        }else{
            navigate("/associationview/"+id)
        }
        
    }


    const editlisting = () => {

        setUserRole(localStorage.getItem('userrole'))

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: associationurl+id,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            setSelectedSchool(response.data.schools)
            setRes(response.data.data);
            let data = {
                name: response.data.data.name,
                email: response.data.data.email,
                sports_id: response.data.data.sport.id,
                phone: response.data.data.phone,
                address: response.data.data.address,
                city: response.data.data.city,
                state: response.data.data.state,
                zip: response.data.data.zip,
                street: response.data.data.street,
                pri_name: response.data.data.pri_firstname,
                pri_lastname: response.data.data.pri_lastname,
                pri_email: response.data.data.pri_email,
                pri_phone: response.data.data.pri_phone,
                pri_address: response.data.data.pri_address,
                pri_street: response.data.data.pri_street,
                pri_city: response.data.data.pri_city,
                pri_state: response.data.data.pri_state,
                pri_zip: response.data.data.pri_zip,
                sec_name: response.data.data.sec_name,
                sec_email: response.data.data.sec_email,
                sec_phone: response.data.data.sec_phone,
                sec_address: response.data.data.sec_address,
                sec_street: response.data.data.sec_street,
                sec_city: response.data.data.sec_city,
                sec_state: response.data.data.sec_state,
                sec_zip: response.data.data.sec_zip,
            }
            reset(data);
            setEmail(response.data.data.email)

            let arrData = [];
            for(let i=0; i<response.data.schools.length; i++)
            {
                arrData = [...arrData, response.data.schools[i].id]

            }

            setSchool_id(arrData)

            }).catch((error) =>{
            
            console.log('error',error.message)
 
            });
    }
  
    const [sportsResult, setSportsResult] = useState([]);
    const SportsListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
   
        const instance = axios.create({
            baseURL: sportlist+'?page='+0+'&size='+100,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          instance.get('').then((response) =>{
            setSportsResult(response.data.data.items);
            SchoolListing();
            editlisting();
            //setSports_id(response.data.data.items.school_id);
            // console.log(response.data.data)
          }).catch((error) =>{   
            console.log('error',error.message)
          });
    }

    const [schoolResult, setSchoolResult] = useState([]);
    const SchoolListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsApiurl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSchoolResult(response.data.data);
            // console.log("schoolListin", response.data.data)

           
          }).catch((error) =>{
            
            console.log('error',error.message)
          });
    }








    const onEditForm = (data) => {

        setBtnLoader(true)

            let token = "Bearer "+localStorage.getItem('token');

            data.school_id = school_id;
            
            const instance = axios.create({

                baseURL: associationurl+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{
                

                let userrole = localStorage.getItem('userrole');

                setTimeout(() => {

                    if(response.data.message === "Email already used in other role"){
                        message.error({content:'Email already used in other role. Please change your email', duration:5});
                        setBtnLoader(false)
                    }else{
                        if(userrole === 'SUPERADMIN'){
                            navigate("/associations")
                        }else{
                            navigate("/associationview/"+id)
                        }
                        setBtnLoader(false)
                    }


                }, 1500);

            
            }).catch((error) =>{

                setBtnLoader(false)

                if(error?.response?.data?.message === "Email already used in other role"){
                    message.error({content:'Email already used in other role. Please change your email', duration:5});
                }
                
                console.log('error', error?.response?.data?.message) 

            }); 
    }

    const validationSchema = yup.object().shape({
        name: yup.string().required('Name is required').min(2, 'Name must be at least 2 characters'),
        sports_id: yup.string().required('Sports is required'),
        phone: yup.string().required('Phone is required'),
        email: yup.string().required('Email is required').email('Please enter valid email'),
        pri_name: yup.string().required('Assignor first name is required'),
        pri_lastname: yup.string().required('Assignor last name is required'),
        pri_email: yup.string().required('Email is required').email('Please enter valid email'),
        pri_phone: yup.string().required('Phone is required'),
    })

    const onSubmit = data => {
        if(data.email !== email){
            // alert for changing email
            confirm({
                title: 'The new email ID updated will become the login ID of the association. Do you want to continue ?',
                // icon: <ExclamationCircleOutlined />,
                // content: 'The email changed will not effect on other e'
                onOk() {
                    data.check = changeAll
                    onEditForm(data)
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }else{
            data.check = changeAll
            onEditForm(data)
        }
        
    }

    const { handleSubmit, register, reset, formState:{errors} } = useForm({
        resolver: yupResolver(validationSchema),
    })


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <h2 className="page-title">Update Association</h2>
                        </div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {userrole === "ASSOCIATION_USER"?(
                                associationIds.length === 1?null:
                                <li class="breadcrumb-item"><Link to="/select_association">Home</Link></li>
                                ):
                                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            }
                            {userrole === "ASSOCIATION_USER"?
                                <li className="breadcrumb-item"><Link to={"/associationview/"+id}>Association View</Link></li>:
                                <li className="breadcrumb-item"><Link to="/associations">Association</Link></li>
                            }
                            <li className="breadcrumb-item active" aria-current="page">Update Association</li>
                        </ol>
                    </nav>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                
                                <Panel className="asso_header" style={{padding:"0", paddingTop:'5px'}} header={`Association Details`} />

                                
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Association Name<span style={{color: "red"}}>*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                {...register('name')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Name"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label >Association Email<span style={{color: "red"}}>*</span></label>
                                            <input type="text" 
                                                name="email"
                                                {...register('email')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Name"
                                            />
                                            {
                                                errors.email && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.email?.message}</div>
                                            }
                                        </div>

                                    </div>
							    </div>

                                <div className="form-group">
                                    <div className="row">

                                        <div className="col-md-12">
                                            <label >Sport<span style={{color: "red"}}>*</span></label>
                                            <select type="dropdown" className="form-control justshow bg-dark" name="sports_id" {...register('sports_id')}>
                                            <option value="">Select Sport</option>
                                                    {
                                                        sportsResult?.map((item,index)=>
                                                            (
                                                                item.status === 'ACTIVE'?
                                                                <option key={index} selected = {sports_id === item.id} value={item.id}>{item.name}</option> : null   
                                                            )
                                                        )
                                                    }
                                            </select>        
                                        {
                                            errors.sports && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sports?.message}</div>
                                        }                         
                                        </div>

                                    </div>
							    </div>




                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label >GIAA Member Schools</label>		
                                                <Multiselect
                                                    placeholder={school_id?.length===0?"You can type and select multiple schools":"Select"}
                                                    className="multi-select"
                                                    options={schoolResult}
                                                    selectedValues={selectedSchool}
                                                    defaultValue={schoolResult}
                                                    selected = {sports_id === schoolResult}
                                                    value={schoolArray}
                                                    onSelect={handleSelect}
                                                    onRemove={handleRemove} 
                                                    displayValue="name" />

                                        </div>
                                    </div>
							    </div>
                               

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Phone</label> 
                                            <input type="text" 
                                                name="phone"
                                                {...register('phone')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="XXX-XXX-XXXX"
                                            />
                                            {
                                                errors.phone && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.phone?.message}</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Address</label>
                                            <input type="text"
                                                name="address"
                                                {...register('address')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Address"
                                            />
                                            {
                                                errors.address && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.address?.message}</div>
                                            }
                                        </div>
                                    </div>
							    </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Street</label>
                                            <input type="text"
                                                name="street"
                                                {...register('street')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Street"
                                            />
                                            {
                                                errors.street && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.street?.message}</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <label >City</label>
                                            <input type="text"
                                                name="city"
                                                {...register('city')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter City"
                                            />
                                            {
                                                errors.city && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.city?.message}</div>
                                            }
                                        </div>

                                    </div>
							    </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >State</label>
                                            <input type="text" 
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter State"
                                                name="state"
                                                {...register('state')}
                                            />
                                            {
                                                errors.state && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.state?.message}</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Zip Code</label>
                                            <input
                                                type="text" 
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Zip Code"
                                                name='zip'
                                                {...register('zip')}
                                            />
                                            {
                                                errors.zip && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.zip?.message}</div>
                                            }
                                        </div>
                                    </div>
							    </div>


                                <Panel className="asso_header" style={{padding:"0", paddingTop:'5px'}} header={`Assignor Details`} />


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Assignor First Name</label>
                                            <input
                                                type="text"
                                                name="pri_name"
                                                {...register('pri_name')}
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Assignor First Name"
                                            />
                                           {
                                            errors.pri_name && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_name?.message}</div>
                                           }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Assignor Last Name</label>
                                            <input type="text" 
                                            name="pri_lastname"
                                            {...register('pri_lastname')}
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Assignor Last Name"/>
                                            {
                                                errors.pri_lastname && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_lastname?.message}</div>
                                            }
                                        </div>
                                    </div>

							    </div>


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Assignor Email</label>
                                            <input
                                                type="text" 
                                                className="form-control justshow bg-dark" 
                                                placeholder="Enter Assignor Email"
                                                name="pri_email"
                                                {...register('pri_email')}
                                            />
                                            {
                                                errors.pri_email && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_email?.message}</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Assignor Phone</label>
                                            <input
                                                type="text" 
                                                className="form-control justshow bg-dark" 
                                                placeholder="XXX-XXX-XXXX"
                                                name="pri_phone"
                                                {...register('pri_phone')}
                                            />
                                            {
                                                errors.pri_phone && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_phone?.message}</div>    
                                            }
                                        </div>
                                    </div>

							    </div>

                                <div className="form-group">
                                    <div className="row">

                                        <div className="col-md-6">
                                            <label >Assignor Address</label>
                                            <input type="text"
                                            name="pri_address"
                                            {...register('pri_address')}
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Assignor Address"
                                            />
                                            {
                                                errors.pri_address && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_address?.message}</div>
                                            }
                                        </div>

                                        <div className="col-md-6">
                                            <label >Assignor Street</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Assignor Street"
                                            name='pri_street'
                                            {...register('pri_street')}
                                            />
                                            {
                                                errors.pri_street && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_street?.message}</div>
                                            }
                                        </div>

                                    </div>

							    </div>




                                <div className="form-group">
                                    <div className="row">


                                        <div className="col-md-6">
                                            <label >Assignor City</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Assignor City"
                                            name='pri_city'
                                            {...register('pri_city')}
                                            />
                                            {
                                                errors.pri_city && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_city?.message}</div>
                                            }
                                        </div>

                                        <div className="col-md-6">
                                            <label >Assignor State</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Assignor State"
                                            name='pri_state'
                                            {...register('pri_state')}
                                            />
                                            {
                                                errors.pri_state && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_state?.message}</div>
                                            }
                                        </div>


                                    </div>
							    </div>


                                <div className="form-group">
                                    <div className="row">


                                        <div className="col-md-6">
                                            <label >Assignor Zip</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Assignor Zip"
                                            name='pri_zip'
                                            {...register('pri_zip')}
                                            />
                                            {
                                                errors.pri_zip && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.pri_zip?.message}</div>
                                            }
                                        </div>

                                    </div>
							    </div>





                                <Panel className="asso_header" style={{padding:"0", paddingTop:'5px'}} header={`Secretary Details`} />


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Secretary Name/Treasurer Name</label>
                                            <input type="text" 
                                            name="sec_name"
                                            {...register('sec_name')}
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Secretary Name/Treasurer Name"
                                            />
                                            {
                                                errors.sec_name && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_name?.message}</div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <label >Secretary Email/Treasurer Email</label>
                                            <input type="text" 
                                            name="sec_email"
                                            {...register('sec_email')}
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Secretary Email/Treasurer Email"/>
                                            {
                                                errors.sec_email && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_email?.message}</div>
                                            }
                                        </div>
                                    </div>

							    </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Secretary Phone/Treasurer Phone</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark"
                                            name="sec_phone"
                                            {...register('sec_phone')}
                                            placeholder="XXX-XXX-XXXX"/>
                                           {
                                                errors.sec_phone && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_phone?.message}</div>
                                           }
                                        </div>

                                        <div className="col-md-6">
                                            <label >Secretary Address/Treasurer Address</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            name="sec_address"
                                            {...register('sec_address')}
                                            placeholder="Enter Secretary Address/Treasurer Address"/>
                                            {
                                                errors.sec_address && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_address?.message}</div>
                                            }
                                        </div>

                                    </div>
							    </div>


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Secretary Street/Treasurer Street</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark"
                                            name="sec_street"
                                            {...register('sec_street')}
                                            placeholder="Enter Secretary Street/Treasurer Street"
                                            />
                                            {
                                                errors.sec_street && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_street?.message}</div>
                                            }
                                        </div>

                                        <div className="col-md-6">
                                            <label >Secretary City/Treasurer City</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            name="sec_city"
                                            {...register('sec_city')}
                                            placeholder="Enter Secretary City/Treasurer City"/>
                                            {
                                                errors.sec_city && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_city?.message}</div>
                                            }
                                        </div>

                                    </div>
							    </div>


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Secretary State/Treasurer State</label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            name="sec_state"
                                            {...register('sec_state')}
                                            placeholder="Enter Secretary State/Treasurer State"/>
                                            {
                                                errors.sec_state && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_state?.message}</div>
                                            }
                                        </div>

                                        <div className="col-md-6">
                                            <label >Secretary Zip/Treasurer Zip</label>
                                            <input 
                                                type="text" 
                                                className="form-control justshow bg-dark" 
                                                name="sec_zip"
                                                {...register('sec_zip')}
                                                placeholder="Enter Secretary Zip/Treasurer Zip"
                                            />
                                            {
                                                errors.sec_zip && <div style={{color:'red', fontSize:'14px', paddingTop:'5px'}}>{errors?.sec_zip?.message}</div>
                                            }
                                        </div>

                                    </div>
							    </div>

       

                            
                                <div className="form-group" style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                                    <div>
                                        {/* <Checkbox onChange={(e)=>{setChangeAll(e)}} defaultSelected={changeAll}>
                                            <span style={{fontSize:'14px'}}>All Associations Name Change</span>
                                        </Checkbox>  */}
                                    </div>
                                    <div>
                                        <button onClick={RoutToList} className="btn btn-danger btn-gisa" type="submit"><div style={{minWidth:'60px'}}>Cancel</div></button>
                                        <button 
                                            // onClick={onEditForm} 
                                            disabled={btnLoader?true:false} 
                                            className="btn btn-primary btn-gisa" 
                                            type="submit"
                                        >{
                                            btnLoader ? 
                                            <div  style={{minWidth:'60px'}} className="d-flex justify-content-center">
                                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                            :
                                            <div style={{minWidth:'60px'}}>
                                                Save
                                            </div>
                                        }
                                        </button>
                                    </div>
							    </div>

                                

                                </div>
                            </div>
                        </div>
                    </form>





                </div>
            </aside>
        </div>

    )
}

export default Editassociation;
